import React, { useState } from 'react';
import no_image from '../assets/no_image.jpg';
import { translate } from '../translations/translations.js';
import { translateCity } from '../translations/cityTranslations.js';
import { applyGrammar } from '../translations/grammarApplier.js';

const POIList = ({ pois, ratings, language, onRate }) => {
  const getRatingForPOI = (poi_id) => {
    const ratingEntry = ratings.find(entry => entry.poi_id === poi_id);
    return ratingEntry ? ratingEntry.rating : '';
  };

  return (
    <div className="poi-list">
      {pois.map((poi) => (
        <div key={poi.poi_id} className="poi-card rating-card">
          <img
            src={
              poi.photo_blob
                ? `data:image/jpeg;base64,${poi.photo_blob}`
                : poi.photo_url || no_image
            }
            className="poi-image"
            loading="lazy"
            onError={(e) => { e.target.src = no_image }}
          />
          <div className="poi-info">
            <div className="poi-text">
              <h3>{language === 'en' ? (poi.name_en || poi.name) : (poi.name_pt || poi.name)}</h3>
              <p>{poi.category}</p>
            </div>
            <div className="rating-input">
              <select
                className="input-rating"
                value={getRatingForPOI(poi.poi_id)}
                onChange={(e) => onRate(poi.poi_id, parseFloat(e.target.value))}
                
              >
                <option value="" disabled hidden>
                  
                </option>
                <option value="2">1</option>
                <option value="3">1.5</option>
                <option value="4">2</option>
                <option value="5">2.5</option>
                <option value="6">3</option>
                <option value="7">3.5</option>
                <option value="8">4</option>
                <option value="9">4.5</option>
                <option value="10">5</option>
              </select>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};


const RateVisitedPOIsForm = ({ currentCity, pois, language, onNavigate }) => {
  const [ratings, setRatings] = useState([]);
  const [warning, setWarning] = useState(false);

  const handlePOIRating = (poi_id, rating) => {
    setWarning(false); 
    setRatings((prev) => {
      const filtered = prev.filter(entry => entry.poi_id !== poi_id);
      if (!rating || rating < 1 || rating > 10) return filtered;
      return [...filtered, { poi_id, rating }];
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const ratedIds = new Set(ratings.map(r => r.poi_id));
    const unratedCount = pois.filter(poi => !ratedIds.has(poi.poi_id)).length;

    if (unratedCount > 0) {
      setWarning(true);
      setTimeout(() => setWarning(false), 4000); // hide after 4s
      return;
    }

    setWarning(false);
    onNavigate(ratings);
  };

  return (
    <form className="form-grid" onSubmit={handleSubmit}>
      <header className="form-header">
        <h1>{applyGrammar(translate('ratePOIsPrompt', language).replace("X", translateCity(currentCity["name"], language).replace(/\((.*?)\)/g, '$1')), language)}</h1>
      </header>
      <div className="form-container-grid">
        <POIList
          pois={pois.sort((a, b) => b.poi_popularity - a.poi_popularity)}
          ratings={ratings}
          language={language}
          onRate={handlePOIRating}
        />
      </div>

      {warning && (
        <div className="warning-message">
          {translate('ratingWarning', language) || "Please rate all attractions before continuing."}
        </div>
      )}

      <button type="submit">{translate('submit', language)}</button>
    </form>
  );
};


export default RateVisitedPOIsForm